import { createContext, useContext, useEffect } from "react";
import { Country } from "../components/routeComponents/Locations/Country";
import { Location } from "../components/routeComponents/Locations/Location";
import { countryListQuery } from "../components/supportFunctions/graphql/LocationsQueries";
import {
  getPagination,
  PaginationQueryObject,
} from "../components/supportFunctions/graphql/Queries";
import { SessionContext, SessionContextType } from "./SessionContext";
import { useSessionStorageState } from "../hooks/useSessionStorageState";
import GatewayService from "../services/GatewayService";

export type Locations = Location[];
export type LocationContextProps = {
  countryList?: Country[];
  isCountryListLoaded?: boolean;
};

export const LocationsContext = createContext<LocationContextProps>({});

export const useLocationsContext = () => useContext(LocationsContext);

export const countriesSessionStorageKey = "countryList";

const LocationsProvider = ({ ...props }) => {
  const [countryList, setCountryList] = useSessionStorageState<Country[]>(
    countriesSessionStorageKey,
    []
  );

  const userContext: SessionContextType = useContext(SessionContext);

  const isCountryListLoaded = countryList?.length > 0;

  const getCountryList = () => {
    const paginationInput: PaginationQueryObject = getPagination(1, 300, null);
    GatewayService.api
      .post("", countryListQuery(null, paginationInput))
      .then((response: any) => {
        const countries = response.data.data.countryList.items;
        setCountryList(countries);
      })
      .catch((error: any) => {
        /* eslint-disable-next-line no-console */
        console.log(error);
      });
  };

  useEffect(() => {
    if (!userContext.isLoading && !isCountryListLoaded) {
      getCountryList();
    }
    // eslint-disable-next-line
  }, [userContext.isLoading]);

  return (
    <LocationsContext.Provider
      value={{
        countryList,
        isCountryListLoaded,
      }}
    >
      {props.children}
    </LocationsContext.Provider>
  );
};

export default LocationsProvider;
